var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVotaSuper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.17,
    height: 86.17,
    viewBox: "0 0 86.17 86.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10126",
    "data-name": "Raggruppa 10126",
    transform: "translate(-287.247 -254.017)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1815",
    "data-name": "Ellisse 1815",
    cx: 43.085,
    cy: 43.085,
    r: 43.085,
    transform: "translate(287.247 254.017)",
    fill: "#33a766"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10106",
    "data-name": "Raggruppa 10106",
    transform: "translate(0.534 15.734)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1816",
    "data-name": "Ellisse 1816",
    cx: 7.153,
    cy: 8.314,
    rx: 7.153,
    ry: 8.314,
    transform: "translate(293.922 274.446)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1817",
    "data-name": "Ellisse 1817",
    cx: 7.153,
    cy: 8.314,
    rx: 7.153,
    ry: 8.314,
    transform: "translate(351.368 274.446)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1818",
    "data-name": "Ellisse 1818",
    cx: 28.374,
    cy: 29.584,
    rx: 28.374,
    ry: 29.584,
    transform: "translate(301.772 251.783)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32547",
    "data-name": "Tracciato 32547",
    d: "M339.485,294.549a9.284,9.284,0,0,1-9.339,6.807,9.5,9.5,0,0,1-9.463-6.807Z",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32548",
    "data-name": "Tracciato 32548",
    d: "M320.312,285.064a3.512,3.512,0,0,0-3.518-2.6,3.593,3.593,0,0,0-3.565,2.6",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32549",
    "data-name": "Tracciato 32549",
    d: "M347.069,285.064a3.512,3.512,0,0,0-3.518-2.6,3.593,3.593,0,0,0-3.565,2.6",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotaSuper);
export default __webpack_public_path__ + "static/media/vota-super.56435d1b37070aeab062f31aa45e543e.svg";
export { ForwardRef as ReactComponent };